import script from "./designations-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./designations-modal.vue?vue&type=script&setup=true&lang=js"

import "./designations-modal.vue?vue&type=style&index=0&id=f825f3ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f825f3ce"]])

export default __exports__